import Api from "../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            }
        ],
        dataTableOptions: {
            server_mode: true,
            global_search: {
                visibility: false,
            }
        },
        searchFields: [
            {
                name: "oepTtt",
                label: "TTT kód",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "oepNev",
                label: "Név",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "jogcim",
                label: "Jogcím",
                formSize: 3,
                formVisible: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getJogcimList,
                    formatText: function(val){
                        return val.text;
                    },
                    formatOption: function(val){
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "hatoanyag",
                label: "Hatóanyag",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "oepAtc",
                label: "ATC kód",
                formVisible: true,
                formSize: 3,
                formType: 'text'
            },
            {
                name: "brandnev",
                label: "Brand",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "tipus",
                label: "Típus",
                formSize: 3,
                formVisible: true,
                formType: 'select',
                selectOptions: {
                    externalOptionList: [
                        {id: 'G', text: 'Gyógyszer'},
                        {id: 'T', text: 'Tápszer'},
                        {id: 'R', text: 'Radiofarmakon'},
                        {id: 'H', text: 'Homeopátiás gyógyszer'},
                        {id: 'A', text: 'Alapanyag'},
                        {id: 'F', text: 'FoNo'},
                        {id: 'C', text: 'Csomagolóanyag'},
                        {id: 'K', text: 'Készítési díj'},
                        {id: 'S', text: 'Gyógyászati segédeszköz'}
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'seeRow'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false,
                formVisible: false,
                formType: 'text',
            },
            {
                name: "oepTtt",
                label: "TTT kód",
                visibility: true,
                slot_name: 'formatGYSE',
                formVisible: true,
                formSize: 2,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "tipus",
                label: "Típus",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 1,
                formReadOnly: true
            },
            {
                name: "oepDat",
                label: "Érvényesség kezdete",
                visibility: false,
                formVisible: true,
                formType: 'date',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "oepEan",
                label: "EAN kód",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "oepAtc",
                label: "ATC kód",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "oepTk",
                label: "OEP törzskönyvi száma",
                visibility: true,
                slot_name: "gyogyszer_szinezes",
                formVisible: true,
                formSize: 3,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "oepNev",
                label: "Gyógyszernév",
                sort: true,
                visibility: true,
                formVisible: true,
                formType: 'text',
                formSize: 4,
                formReadOnly: true
            },
            {
                name: "oepKsz",
                label: "Kiszerelés",
                visibility: true,
                formVisible: true,
                formType: 'text',
                formSize: 3,
                formReadOnly: true
            },
            {
                name: "hatoanyag",
                label: "Hatóanyag",
                visibility: true,
                formVisible: true,
                formType: 'text',
                formSize: 3,
                formReadOnly: true
            },
            {
                name: "adagmod",
                label: "Adagolás módja",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "idGyforma",
                label: "Gyógyszer forma ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "gyforma",
                label: "Gyógyszerforma",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "rendelhet",
                label: "Rendelhet",
                visibility: false,
                formVisible: false
            },
            {
                name: "egyenid",
                label: "Egyenértékűségi csoport ID",
                visibility: false,
                formVisible: false,
            },
            {
                name: "potencia",
                label: "Potencia",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "ohatoMenny",
                label: "Összes hatóanyag tartalom",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "hatoMenny",
                label: "Egy kiszerelési egységben lévő hatóanyag mennyiség",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "hatoEgys",
                label: "Egy kiszerelési egységben lévő hatóanyag egység",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "kiszMenny",
                label: "Kiszerelés mennyiség",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "kiszEgys",
                label: "Kiszerelés egység",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "dddMenny",
                label: "DDD értéke",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "dddEgys",
                label: "DDD mennyiség egysége",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "dddFaktor",
                label: "Hatóanyag egys. és DDD egys. váltószám",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "dot",
                label: "Kiszerelés hány napra elegendő",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "adagMenny",
                label: "Kiszerelés hány egységnek megfelelő mennyiség",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "adagEgys",
                label: "Szokásosan felírt mennyiség egység",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "oepTar",
                label: "Termelői ár",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "oepNkar",
                label: "Nagykereskedelmi ár",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "oepFan",
                label: "Fogyasztói ár (nettó)",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "oepFab",
                label: "Fogyasztói ár (bruttó)",
                visibility: true,
                slot_name: "commission_format",
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "oepAfa",
                label: "ÁFA",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "ntk",
                label: "Napi terápiás költésg",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "oepItm",
                label: "Régi támogatásjelzés",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "oepJc1",
                label: "Honvédelmi jogosultsággal felírható",
                visibility: false,
                formVisible: false
            },
            {
                name: "oepJc2",
                label: "Közgyógy ellátott betegeknek felírható ",
                visibility: false,
                formVisible: false
            },
            {
                name: "oepJc3",
                label: "Üzemi baleset esetén felírható",
                visibility: false,
                formVisible: false
            },
            {
                name: "oepJc4",
                label: "EÜ kiemelt jogosultsággal felírható",
                visibility: false,
                formVisible: false
            },
            {
                name: "oepJc5",
                label: "EÜ emelt jogosultsággal felírható",
                visibility: false,
                formVisible: false
            },
            {
                name: "kgykeret",
                label: "Közgyógy keret meghatározásakor figyelembe vehető?",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "egysegar",
                label: "Hatóanyag egységára",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "normTip",
                label: "Támogatásra vonatkozó megjelölés",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "normSzaz",
                label: "Támogatás mértéke %",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "normFixid",
                label: "Normatív fixcsoport ID",
                visibility: false,
                formVisible: false,
            },
            {
                name: "normRefntk",
                label: "Normatív fixcsoport referencia NTK-ja ",
                visibility: false,
                formVisible: false,
            },
            {
                name: "oepInn",
                label: "Normatív támogatás nettó",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "oepInb",
                label: "Normatív támogatás bruttó",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "normTerdij",
                label: "A beteg által fizetendő térítési díj (normatív)",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "ntkTd",
                label: "A beteg által fizetendő térítési díj alapján kiszámított napi terápiás költség",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "normMihaid",
                label: "Minőségi és Hatékony Gyógyszerrendelési Ösztönzés - csoportazonosító",
                visibility: false,
                formVisible: false
            },
            {
                name: "normMihacel",
                label: "Minőségi és Hatékony Gyógyszerrendelési Ösztönzés - a gyógyszer csoportjának célértéke",
                visibility: false,
                formVisible: false
            },
            {
                name: "normMihastat",
                label: "Minőségi és Hatékony Gyógyszerrendelési Ösztönzés - a gyógyszer státusza",
                visibility: false,
                formVisible: false
            },
            {
                name: "normKihi",
                label: "Normatív jogcímen a kihordási idő ",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "normFelme",
                label: "Normatív jogcímen a felírható mennyiség ",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "euemTip",
                label: "Az EÜ emelt támogatás technikája",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "euemSzaz",
                label: "Támogatás mértéke %-ban EÜ emelt támogatás esetén",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "euemFixid",
                label: "EÜ emelt fixcsoport azonosítója",
                visibility: false,
                formVisible: false
            },
            {
                name: "euemRefntk",
                label: "EÜ emelt fixcsoport referencia NTK-ja",
                visibility: false,
                formVisible: false
            },
            {
                name: "oepEun",
                label: "EÜ emelt támogatás nettó",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "oepEub",
                label: "EÜ emelt támogatás bruttó",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "euemTerdij",
                label: "A beteg által fizetendő térítési díj (EÜ emelt támogatás esetén)",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "ntkEetd",
                label: "A beteg által fizetendő térítési díj alapján kiszámított napi terápiás költség (EÜ emelt támogatás esetén)",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "euemPontok",
                label: "EÜ pontok, amire a termék EÜ emelt támogatással írható",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "euemKihi",
                label: "EÜ emelt jogcímen a kihordási idő",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "euemFelme",
                label: "EÜ emelt jogcímen a felírható mennyiség",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "eukiemTip",
                label: "Az EÜ kiemelt támogatás technikája",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "eukiemSzaz",
                label: "Támogatás mértéke %-ban EÜ kiemelt támogatás esetén",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "eukiemFixid",
                label: "EÜ kiemelt fixcsoport azonosítója",
                visibility: false,
                formVisible: false
            },
            {
                name: "eukiemRefntk",
                label: "EÜ kiemelt fixcsoport referencia NTK-ja",
                visibility: false,
                formVisible: false
            },
            {
                name: "oepEu100n",
                label: "EÜ kiemelt támogatás nettó",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "oepEu100b",
                label: "EÜ kiemelt támogatás bruttó",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "eukiemTerdij",
                label: "A beteg által fizetendő térítési díj (EÜ kiemelt támogatás esetén)",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "ntkEktd",
                label: "A beteg által fizetendő térítési díj alapján kiszámított napi terápiás költség (EÜ kiemelt támogatás esetén)",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "eukiemPontok",
                label: "EÜ pontok, amire a termék EÜ kiemelt támogatással írható",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "eukiemKihi",
                label: "EÜ kiemelt jogcímen a kihordási idő",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "eukiemFelme",
                label: "EÜ kiemelt jogcímen a felírható mennyiség",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "forgalomban",
                label: "Forgalomban?",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },{
                name: "besorolas",
                label: "A költséghatékonysági kategória kódja jogcímenként ",
                visibility: false,
                formVisible: false
            },
            {
                name: "prasTermek",
                label: "PReferált ÁrSávba tartozó termék",
                visibility: false,
                formVisible: false
            },
            {
                name: "patika",
                label: "Patikában/patikán kívül kapható",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },{
                name: "egyedi",
                label: "Egyedi méretvétel alapján?",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "oepIso",
                label: "Gyógyászati segédeszköz azonosító ISO kódja",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "forgengtId",
                label: "Forgalomba hozatali engedély jogosultja/Gyártó ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "keresztjelzes",
                label: "OGYI hatáserősség (méregosztály) jelzése",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2,
                formReadOnly: true
            },
            {
                name: "rendelhetoseg",
                label: "Rendelhetőség",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 4,
                formReadOnly: true
            },
            {
                name: "forgengt",
                label: "Forgalomba hozatali engedély jogosultja/Gyártó",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 4,
                formReadOnly: true
            },
            {
                name: "forgalmazId",
                label: "Forgalmazó ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "forgalmaz",
                label: "Forgalmazó",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 4,
                formReadOnly: true
            },
            {
                name: "brandId",
                label: "A gyógyszer márkanevének azonosítója",
                visibility: false,
                formVisible: false
            },
            {
                name: "brandnev",
                label: "A gyógyszer márkaneve",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 4,
                formReadOnly: true
            },
            {
                name: "kestTerm",
                label: "Kedvezményezett státuszú termék?",
                visibility: false,
                formVisible: false
            },
            {
                name: "kozhid",
                label: "OGYI termékazonosító",
                visibility: false,
                formVisible: false
            },
            {
                name: "nicheId",
                label: "nicheId",
                visibility: false,
                formVisible: false
            },
            {
                name: "regiNev",
                label: "Az átnevezett készítmény / eszköz korábbi neve",
                visibility: false,
                formVisible: false
            },
            {
                name: "switch",
                label: "Változás kódja",
                visibility: false,
                formVisible: false
            },
            {
                name: "tktorles",
                label: "A törzskönyvből törölt készítmények megjelölése",
                visibility: false,
                formVisible: false
            },
            {
                name: "tktorlesdat",
                label: "A készítmény törzskönyvi törlésének dátuma",
                visibility: false,
                formVisible: false
            },
            {
                name: "createdBy",
                label: "createdBy",
                visibility: false,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "createdOn",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                visibility: false,
                formVisible: false
            },
            {
                name: "deleted",
                label: "deleted",
                visibility: false,
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        eupontokRowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'seeEupont'
            }
        ],
        eupontokHeaderFields: [
            {
                name: "assistanceType",
                label: "Támogatás típusa",
                visibility: true,
            },
            {
                name: "codeNum",
                label: "Kódszám",
                visibility: true,
            },
            {
                name: "perjel",
                label: "Perjel",
                visibility: true,
            },
            {
                name: "euindikacio.leiras",
                label: "Indikáció leírása",
                visibility: true,
            },
            {
                name: "indTip",
                label: "Indikáció típusa",
                visibility: true,
            },
            {
                name: "prescription",
                label: "GYSE felírási megjegyzések",
                visibility: true,
            },
            {
                name: "comment",
                label: "GYSE rendelhetőségi feltételek",
                visibility: true,
            },
            {
                name: "id",
                label: "ID",
                visibility: false,
            },
            {
                name: "bnoCodes",
                label: "BNO kódok",
                visibility: false,
            },
            {
                name: "eujoghozzarList",
                label: "EU Jog lista",
                visibility: false,
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        bnoKodHeaderFields: [
            {
                name: "kod",
                label: "Kód",
                filter: {
                    type: "simple",
                }
            },
            {
                name: "leiras",
                label: "Leírás",
                filter: {
                    type: "simple",
                }
            }
        ],
        eujogHeaderFields: [
            {
                name: "kategoria",
                label: "Felírási megkötés",
                filter: {
                    type: "simple",
                }
            },
            {
                name: "jogosult",
                label: "Felírási jogosultság",
                filter: {
                    type: "simple",
                }
            },
            {
                name: "szakvkod.leiras",
                label: "Szükséges szakképesítés",
                filter: {
                    type: "simple",
                }
            },
            {
                name: "jidokorlat",
                label: "Időkorlát (hónap)"
            }
        ]
    }
}
